namespace $ { $mol_style_attach( "mol/link/iconed/demo/demo.view.css",
 "[mol_link_iconed_demo_blocks] {\n\tflex: 1;\n}\n"
) }